<template>
  <div id="samba-player"></div>
</template>

<script>
import VideosAPI from '@/api/videos-api'

export default {
  name: 'SambatechPlayer',
  props: {
    ementaId: Number,
    tipoOrigemId: Number,
    urlVideo: {
      type: String,
      required: true
    },
    inicio: Number
  },

  data () {
    return {
      tempoTotalVideo: 0,
      tempoAtualVideo: 0
    }
  },

  created () {
    let scriptSambaPlayerApi = document.createElement('script')
    scriptSambaPlayerApi.setAttribute('src', 'https://beyond.spalla.io/player/js/spalla.player.js')
    document.head.appendChild(scriptSambaPlayerApi)
  },

  async mounted () {
    await new Promise(resolve => setTimeout(resolve, 1000))
    /* eslint-disable */
    var player = new SpallaPlayer('samba-player', {
      videoId: this.mediaId,
      width: "100%",
      height: "100%",
      autoplay: true,
      t: parseInt(this.inicio)
    })

    player.on("*", (e) => {
      this.eventListener(e)
    });

    this.intervalId = setInterval(() => {
        this.concluiVideo()
    }, 3000)
  },

  beforeDestroy(){
    clearInterval(this.intervalId);
  },

  computed: {
    playerHash: function () {
      let arrayUrl = this.urlVideo.split('/')
      return arrayUrl[arrayUrl.length - 2]
    },

    mediaId: function () {
      let arrayUrl = []
      if (this.urlVideo.includes('fast.player')) {
        arrayUrl = this.urlVideo.split('/')
      } else {
        arrayUrl = this.urlVideo.split('video=')
      }
      return arrayUrl[arrayUrl.length - 1]
    },

    autoplay: function () {
      return JSON.parse(localStorage.getItem('autoplay'))
    },

    controleTopico: function () {
      return this.$store.getters.getControleTopico
    }
  },

  methods: {
    eventListener (player) {
      if (player.event == 'progress') {
        this.tempoTotalVideo = player.duration
        this.tempoAtualVideo = player.currentTime
      }
      if (player.event == 'pause') {
        VideosAPI.atualizarTempoVideo(this.ementaId, this.tempoAtualVideo)
      }
    },

    autoplayVideo () {
      if (this.autoplay) {
        window.eventBus.$emit('salvarAnotacao')
        window.eventBus.$on('anotacaoSalva', async () => {
          await this.$store.dispatch('iniciaTimer', 5)
          this.$router.push(this.controleTopico.proximo.url)
        })
      }
    },

    concluiVideo() {
      this.$store.dispatch('concluiEmentaVideo', { ementaId: this.ementaId, tempoAtual: this.tempoAtualVideo, tempoTotal: this.tempoTotalVideo })
    }
  }
}
</script>

<style scoped>

</style>
